import { doesFocusableExist, setFocus } from "@noriginmedia/norigin-spatial-navigation";
import { FIRST_EVENT_KEY } from "../../constants/event";

// Does the row have elements? (live events can have no elements)
const isValidRow = (row) => row?.render && Array.isArray(row.items) && row.items.length > 0;

const findFocusKey = (rows) => {
    for (const row of rows) {
        const prefix = row.rowType;
        const itemCount = row.items.length;
        for (let i = 0; i < itemCount; i++) {
            const focusKey = `${prefix}-${row.rowId}-${i}`;
            if (doesFocusableExist(focusKey)) return focusKey;
        }
    }
    return null;
};

export const getFirstAvailableFocusKey = (rowsData) => {
    const availableRows = rowsData?.filter(isValidRow) || [];
    return findFocusKey(availableRows);
};

export const safeSetFocus = (focusKey) => {
    if (!focusKey) return;

    if (doesFocusableExist(focusKey)) {
        setFocus(focusKey);
    }
};

export const getEPGFirstFocusKey = (rowsData) => {
    // Get the first available
    const focusKey = getFirstAvailableFocusKey(rowsData);
    if (focusKey) return focusKey;

    // Fallback to first live event
    if (doesFocusableExist(FIRST_EVENT_KEY)) {
        return FIRST_EVENT_KEY;
    }

    return null;
};
